import { TOUR_TARGET_ATTRIBUTE, type TourTarget } from '../constants';

export interface SpotlightRect {
  top: number;
  left: number;
  width: number;
  height: number;
}

/**
 * Finds the DOM element marked as the given tour target.
 * @param root - Document or element to search within.
 * @param target - Tour target identifier.
 * @returns The matching element, or `null` when it is not rendered.
 */
export function findTourTarget(root: ParentNode, target: TourTarget): Element | null {
  return root.querySelector(`[${TOUR_TARGET_ATTRIBUTE}="${target}"]`);
}

/**
 * Expands an element's bounding box by a padding to frame it in the spotlight.
 * @param rect - Element bounding box.
 * @param padding - Extra space around the element, in pixels.
 * @returns The padded spotlight rectangle.
 */
export function computeSpotlightRect(rect: DOMRect, padding: number): SpotlightRect {
  return {
    top: rect.top - padding,
    left: rect.left - padding,
    width: rect.width + padding * 2,
    height: rect.height + padding * 2,
  };
}
